import { render, staticRenderFns } from "./FiCustomerSelect.vue?vue&type=template&id=f4af18e0&lang=pug&"
import script from "./FiCustomerSelect.vue?vue&type=script&lang=js&"
export * from "./FiCustomerSelect.vue?vue&type=script&lang=js&"
import style0 from "./FiCustomerSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports